export default "__VITE_ASSET__amssm$OD__"